import { inject, Service } from '@angular/core';
import { ServicesService } from '../services';

@Service()
export class UserSettingEndpointService {
  readonly #service = inject(ServicesService);

  getUserSettings() {
    return this.#service.userService(`user-settings?${new Date().getTime()}`);
  }

  getUserSettingByKey(key: string) {
    return this.#service.userService(
      `user-settings/${key}?${new Date().getTime()}`,
    );
  }

  createSetting() {
    return this.#service.userService('user-settings/create');
  }

  deleteSetting(key: string) {
    return this.#service.userService(`user-settings/${key}`);
  }

  getSetting(key: string) {
    return this.#service.userService(`user-settings/${key}`);
  }
}
